<template>
  <div class="container">
    <div class="card-base p-20">
      <h1 class="h1">
        {{ page.title }}
      </h1>
      <SofieText :value="page.template?.text" />
    </div>
  </div>
</template>

<script setup lang="ts">
const page = useSofiePage();
</script>
